import React, { createContext, useContext, useEffect, useState } from "react";
import { setOfflineMode as persistOfflineMode } from "./offlineMode";

const OfflineContext = createContext();

export function OfflineProvider({ children }) {
  const [offlineMode, setOfflineModeState] = useState(() => {
    return localStorage.getItem("planificador_offline_mode") === "true";
  });
  const setOfflineMode = (value) => {
    localStorage.setItem("planificador_offline_mode", value ? "true" : "false");
    setOfflineModeState(value);
  };

  return (
    <OfflineContext.Provider
      value={{
        offlineMode,
        setOfflineMode,
      }}
    >
      {children}
    </OfflineContext.Provider>
  );
}

export function useOffline() {
  const context = useContext(OfflineContext);

  if (!context) {
    throw new Error("useOffline debe usarse dentro de OfflineProvider");
  }

  return context;
}
